define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var language = require('util/language.util');
    var url = require('util/url.util');
    var history = require('util/history.util');

    module.exports = _.extend(url, {
        // eslint-disable-next-line no-shadow
        replace: function(url) {
            if (this.isExternalUrl(url)) {
                window.location.replace(url);
            } else {
                history.replaceState(null, null, url);
            }
        },

        parseUrlParameters: function(searchString) {
            return this.getURLParams(searchString);
        },

        getCurrentUrl: function() {
            return window.location.pathname + window.location.search + window.location.hash;
        },

        parseLang: function(path) {
            var urlSections = this.getUrlSections(path);
            var lang = urlSections[0] || '';
            lang = language.getLanguage(lang);
            return lang;
        },

        getUrlSections: function(path) {
            return _.compact(path && path.split('/'));
        },

        getBackUrl: function() {
            var params = this.parseUrlParameters();
            return params.back_url || params.backUrl || null;
        },

        /* TotalCasino changes */
        /**
         * Check if open game page
         * @returns {boolean}
         */
        isLaunchGamePath: function(pathname = this.pathname, isAfterLogin = false) {
            var regExp = isAfterLogin ? /\/online-game\/|\/igaming\//g : /igaming\/(?!games-info)/g;

            return regExp.test(pathname);
        }
        /* TotalCasino changes */
    });
});
